// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scan-confirm-dialog[data-v-727292ce] {\n  z-index: 9999;\n  position: absolute;\n  width: inherit;\n}\n.overlay-icon[data-v-727292ce] {\n  position: absolute;\n  width: 100%;\n  z-index: 99999;\n}\n.camera-drawer[data-v-727292ce] {\n  position: relative;\n  max-height: 40vh;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
